import type {RouteLocationNormalizedLoaded} from 'vue-router'

export async function useTourRuntimeData(route: RouteLocationNormalizedLoaded) {
    const arrivalCityId = +route.query.arrivalCityId
    const packageTourId = +route.query.packageTourId
    let departureCityId = null
    if (route.query.departureCityId) departureCityId = +route.query.departureCityId

    if (toursRuntimeStore.departureCity?.id !== departureCityId)
        await toursRuntimeStore.loadDepartureCity(departureCityId)
    if (toursRuntimeStore.arrivalCity.id !== arrivalCityId) await toursRuntimeStore.loadArrivalCity(arrivalCityId)
    if (packageTourId && toursRuntimeStore.packageTourId !== packageTourId)
        await toursRuntimeStore.loadPackageTourInfo(packageTourId)
}
